import { useEffect, useState } from 'react';
import { resolveAvatarUrl } from 'services/api/imageServices';

// Resolves a displayable avatar URL for a user object. Prefers an already
// present user.avatarUrl (e.g. the signed URL stored right after an upload),
// otherwise fetches a signed URL when the user has an avatar in the private
// profile-images bucket. Returns null while unresolved / for users without
// an avatar, so callers can fall back to initials.
export const useAvatarUrl = (user) => {
  const [url, setUrl] = useState(user?.avatarUrl || null);

  useEffect(() => {
    let mounted = true;
    if (user?.avatarUrl) {
      setUrl(user.avatarUrl);
      return undefined;
    }
    if (!user?._id || user?.hasAvatar === false) {
      setUrl(null);
      return undefined;
    }
    resolveAvatarUrl(user).then((resolved) => {
      if (mounted) setUrl(resolved);
    });
    return () => {
      mounted = false;
    };
  }, [user?._id, user?.hasAvatar, user?.avatarUrl]);

  return url;
};
